// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f5039f7c","125":"b40392f6","179":"7b5a91ba","228":"f5be75a5","272":"8ec62dfe","352":"99f7989f","549":"a30bc788","666":"b2c655b9","816":"d37b22d6","930":"5b398b50","996":"0e88fe7f"}[chunkId] + ".chunk.js";
};